<ng-container *ngIf="form;else noForm">
  <div class="container">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-6 col-lg-6" *ngFor="let formField of formFields">
        <ubs-ofbiz-form-field [formField]="formField" [form]="form"></ubs-ofbiz-form-field>
      </div>
      <div class="form-row submit">
        <button type="submit" nbButton status="primary" [disabled]="!form.valid" size="small">Submit</button>
      </div>
    </div>
  </div>
  <!-- <form (ngSubmit)="submit()" [formGroup]="form" class="container" >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6" *ngFor="let formField of formFields">
            <ubs-ofbiz-form-field [formField]="formField" [form]="form"></ubs-ofbiz-form-field>
          </div>
          <div class="form-row submit">
            <button type="submit" nbButton status="primary" [disabled]="!form.valid" size="small">Submit</button>
          </div>
        </div>
    </form> -->
</ng-container>
<ng-template #noForm>
  <p>No form data provided.</p>
</ng-template>